import { css } from "@tento-ui/component-styles";
import { ChatThemes } from "../chat-theme";
import type { ChatTheme } from "../chat-theme";

/**
 * The claude.ai replica (light): #FAF9F5 ivory ground; serif assistant
 * prose; user messages in a warm #F0EEE6 bubble with a #E3DFD3 hairline,
 * uniform 12px corners, sans face; coral #D97757 accent family; JetBrains
 * Mono code on #F2F0EA panels. (Palette from claude.ai's published tokens;
 * the true faces are Anthropic Serif/Sans — closest system stand-ins used.)
 */
export const AnthropicLook: ChatTheme = {
  ...ChatThemes.bubbles(),
  name: "anthropic",
  $style: css`
    :host {
      background: #faf9f5;
      color: #1f1e1d;
      --text-pri: #1f1e1d;
      --text-sec: #535146;
      --text-ter: #83827d;
      font-family: Tiempos, "Iowan Old Style", Georgia, serif;
      font-size: 16px;
      line-height: 1.65;
      --thread-top-inset: 20px;
      --thread-bottom-inset: 20px;
      --chat-turn-inset: max(20px, calc((100% - 768px) / 2));
      --chat-bubble-ground: #f0eee6;
      --chat-bubble-ink: #1f1e1d;
      --chat-bubble-edge: 1px solid #e3dfd3;
      --chat-bubble-radius: 12px;
      --chat-bubble-max-width: 75%;
      --chat-bubble-padding: 10px 14px;
      --chat-bubble-leading: 1.55;
      --chat-bubble-face: "Styrene B", ui-sans-serif, -apple-system,
        "Segoe UI", sans-serif;
      --chat-terminal-bg: #f2f0ea;
      --chat-terminal-fg: #1f1e1d;
      --chat-terminal-edge: 1px solid #dedcd1;
      --chat-terminal-radius: 8px;
      --chat-terminal-size: 13px;
      --chat-terminal-padding: 12px 16px;
      --chat-terminal-font: "JetBrains Mono", ui-monospace, SFMono-Regular,
        monospace;
      --session-replay-ansi-ground: #f2f0ea;
    }
  `,
};
